import { InjectionToken } from '@angular/core';
import { ITokenService } from './ITokenService';

export const ITOKEN_SERVICE = new InjectionToken<ITokenService>('ITOKEN_SERVICE');
